



































































































































































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import {
  Address,
  LobAddressValidationResponse,
  LobAddressValidationResult,
  LobAutoCompleteAddressRequest
} from "@/shared/types";
import {
  getLobSuggestions,
  lobAddressVerification
} from "@/shared/api/userService";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useNotifierStore } from "@/shared/store/notifier";
import _ from "lodash";
import UsStateSelector from "@/shared/components/UsStateSelector.vue";
import { useAddressFormStore } from "@/employee/store/addressForm";

@Component({
  components: {
    UsStateSelector
  }
})
export default class AddressForm extends Vue {
  featureFlagStore = useFeatureFlagStore();
  notifierStore = useNotifierStore();
  addressFormStore = useAddressFormStore();

  LobAddressValidationResult = LobAddressValidationResult;

  @Prop({ default: "Address" })
  title: string;

  @Prop({ required: true })
  formModel: Address;

  @Prop()
  disabled: boolean;

  @Prop()
  showRequiredFieldMarkers: boolean;

  @Watch("saveDisabled")
  onSaveDisabledChanged () {
    this.addressFormStore.saveDisabled = this.saveDisabled;
  }

  @Watch("isValid")
  onIsValidChanged () {
    this.addressFormStore.isValid = this.isValid;
  }

  showLobSuggestion = false;
  lobSuggestions = [];
  useSuggestion = "";
  selectingAddress = false;
  verifiedAddress = false;
  debouncedSearchFunction = _.debounce(text => this.getAddress(text), 600);
  lobSuggestion: LobAddressValidationResponse = {
    isValid: false,
    result: LobAddressValidationResult.None,
    validationFootnotes: null,
    suggestedAddress: {
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: ""
    }
  };
  providedAddress: Address = {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: ""
  };

  get isValid () {
    return !this.$validator.errors.any();
  }

  get saveDisabled () {
    return !this.verifiedAddress && this.showLobSuggestion && this.useSuggestion === "";
  }

  get requiredFieldMarker () {
    return this.showRequiredFieldMarkers ? "*" : "";
  }

  get useLobApi () {
    return this.featureFlagStore.flags.bend17254ProfileLobAddressValidation;
  }

  get suggestedAddress () {
    if (this.lobSuggestion && this.lobSuggestion.suggestedAddress) {
      return this.lobSuggestion.suggestedAddress;
    }

    return {
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: ""
    };
  }

  validate () {
    return this.$validator.validateAll();
  }

  verifyAddress () {
    if (this.verifiedAddress) {
      return Promise.resolve();
    }

    this.providedAddress = {
      addressLine1: this.formModel.addressLine1,
      addressLine2: this.formModel.addressLine2,
      city: this.formModel.city,
      state: this.formModel.state,
      zip: this.formModel.zip
    };

    return lobAddressVerification({
      properCase: true,
      address: {
        addressLine1: this.formModel.addressLine1,
        addressLine2: this.formModel.addressLine2,
        city: this.formModel.city,
        state: this.formModel.state,
        zip: this.formModel.zip
      }
    }).then(response => {
      this.lobSuggestion = response.data;

      if (!response.data.isValid || response.data.result !== LobAddressValidationResult.Confirmed) {
        this.showLobSuggestion = true;
        return Promise.reject();
      }

      return Promise.resolve();
    });
  }

  onSuggestionRadioChecked (value: string) {
    this.verifiedAddress = true;

    if (value === "suggested") {
      this.formModel.addressLine1 = this.lobSuggestion.suggestedAddress.addressLine1;
      this.formModel.addressLine2 = this.lobSuggestion.suggestedAddress.addressLine2;
      this.formModel.city = this.lobSuggestion.suggestedAddress.city;
      this.formModel.state = this.lobSuggestion.suggestedAddress.state;
      this.formModel.zip = this.lobSuggestion.suggestedAddress.zip;
    }
  }

  onEditAddressClicked () {
    this.showLobSuggestion = false;
  }

  async getAddress (address: string) {
    if (this.selectingAddress) {
      this.selectingAddress = false;
      return;
    }

    if (address === undefined || address === "") {
      return;
    }

    try {
      const request: LobAutoCompleteAddressRequest = {
        address,
        city: this.formModel.city,
        state: this.formModel.state,
        zip: this.formModel.zip,
        validSuggestions: true,
        properCase: true,
        geoIpSearch: true
      };

      const response = await getLobSuggestions(request);

      if (response.data.suggestions !== null) {
        this.lobSuggestions = response.data.suggestions.map(a => ({
          ...a,
          fullAddress: `${a.addressLine1} ${a.city}, ${a.state} ${a.zip}`
        }));
      }
    } catch (error) {
      this.handleError(error);
    }
  }

  handleError (error: any) {
    const message = (error && error.errorMessage) || "Error processing your request. Please try again later.";
    this.notifierStore.setDanger(message);
  }

  addressSelected (selectedAddress: any) {
    this.selectingAddress = true;
    this.verifiedAddress = true;

    this.formModel.addressLine1 = selectedAddress.addressLine1;
    this.formModel.city = selectedAddress.city;
    this.formModel.state = selectedAddress.state;
    this.formModel.zip = selectedAddress.zip;

    const typeaheadRef = this.$refs.typeahead as any;
    typeaheadRef.inputValue = this.formModel.addressLine1;
  }

  onInput () {
    if (this.useLobApi) {
      this.verifiedAddress = false;
    }
  }

  onPrimaryAddressInput (text: string) {
    this.verifiedAddress = false;
    this.debouncedSearchFunction(text.trim());
  }
}
